import { useCallback, useEffect, useRef } from "react";

/**
 * Schedules a prefetch after a delay. Each new call cancels the previous timer,
 * so rapid hover-swipes across many elements only fire the last one.
 */
export function useDebouncedPrefetch(delayMs = 500) {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return useCallback(
    (fn: () => void) => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        fn();
        timerRef.current = null;
      }, delayMs);
    },
    [delayMs]
  );
}
